import '../application/javascripts/index.js.erb';
import $ from "jquery";
import hyperform from "hyperform";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.it-CH.min"

$.when($.ready).then(function () {
    hyperform.addTranslation("it",{
        TextTooLong:"Ridurre la lunghezza del testo a %l caratteri o meno (attualmente si stanno utilizzando %l caratteri)",
        TextTooShort:"Utilizzare almeno %l caratteri (attualmente si stanno utilizzando %l caratteri)",
        ValueMissing:"Compilare questo campo",
        CheckboxMissing:"Selezionare questa casella per procedere",
        RadioMissing:"Selezionare una delle opzioni disponibili",
        FileMissing:"Selezionare un file",
        SelectMissing:"Selezionare un elemento dall'elenco",
        InvalidEmail:"Inserire un indirizzo email",
        InvalidURL:"Inserire un URL",
        PatternMismatch:"Inserire un valore nel formato richiesto",
        PatternMismatchWithTitle:"Inserire un valore nel formato richiesto: %l",
        NumberRangeOverflow:"Selezionare un valore inferiore o uguale a %l.",
        DateRangeOverflow:"Selezionare un valore precedente o uguale a %l.",
        TimeRangeOverflow:"Selezionare un valore precedente o uguale a %l.",
        NumberRangeUnderflow:"Selezionare un valore superiore o uguale a %l.",
        DateRangeUnderflow:"Selezionare un valore successivo o uguale a %l.",
        TimeRangeUnderflow:"Selezionare un valore successivo o uguale a %l.",
        StepMismatch:"Selezionare un valore valido. I due valori validi più vicini sono %l e %l",
        StepMismatchOneValue:"Selezionare un valore valido. Il valore valido più vicino è %l",
        BadInputNumber:"Inserire un numero",
    });
    hyperform.setLanguage("it");
    hyperform(window);
    
    window.MutiselectOptions =  {
        enableClickableOptGroups: true,
        maxHeight: 350,
        buttonWidth: '100%',
        buttonClass: 'multiselect dropdown-toggle btn btn-primary btn-left',
        selectAllText: 'seleziona tutto',
        filterPlaceholder: 'cerca',
        nonSelectedText: 'nessuna selezione',
        nSelectedText: 'selezionato',
        allSelectedText: 'tutti selezionati',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        enableFullValueFiltering: true,
        templates: {
            filter: '<li class="multiselect-item filter"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search"></i></span><input class="form-control multiselect-search" type="text"></div></li>'
        }
    };

    $('#mobile-nav').hcOffcanvasNav({
        maxWidth: false,
        levelTitles: true,
        pushContent: false,
        closeLevels: true,
        position: 'right',
        customToggle: $('.toggle'),
        labelClose: 'chiudere',
        labelBack: 'Indietro'
    });
    
});
